import React from 'react'
import PushServiceItem from '../PushServiceItem'
import './index.css'

/**
 * 推送服务,和新闻推送的方案名称输入组件
 */
interface PushServerNameProps {
    value: string
    onChange: (s: string) => void
}

const PushServerName: React.FC<PushServerNameProps> = (props) => {
    return (
        <PushServiceItem>
            <p className='pushServiceNameTitle'>配置名称</p>
            <input
                className='pushServiceNameInput'
                value={props.value}
                onChange={(e) => props.onChange(e.target.value)}
            />
        </PushServiceItem>
    )
}

export default PushServerName
